import TradingViewWidget from "./chart-section/TradingViewWidget";
import PageHeader from "../../ui/PageHeader";
import SignalsSummary from "./chart-section/SignalsSummary";
import OverallInsights from "./chart-section/OverallInsights";
import ExchangePairConfigs from "./chart-section/ExchangePairConfigs";

function InsightChartSection() {
  return (
    <>
      <PageHeader title="Chart Analysis" service="insight" />
      <ExchangePairConfigs />
      <OverallInsights />
      {/*<LiveSuggestionButton />*/}
      {/*<LiveSuggestionCard />*/}
      <TradingViewWidget />
      {/*<SignalsSummary />*/}
    </>
  );
}

export default InsightChartSection;
